var map = {
	"./Accordion.js": [
		826,
		826
	],
	"./CartToast.js": [
		241,
		241
	],
	"./CheckoutErrors.js": [
		821,
		821
	],
	"./CheckoutSidebar.js": [
		392,
		392
	],
	"./ColorText.js": [
		268,
		268
	],
	"./CtaLanguage.js": [
		340,
		340
	],
	"./Fadein.js": [
		327,
		327
	],
	"./FooterHeight.js": [
		74,
		74
	],
	"./GMap.js": [
		271,
		271
	],
	"./Gmultimap.js": [
		44,
		44
	],
	"./GmultimapIubenda.js": [
		986,
		986
	],
	"./ImageUp.js": [
		556,
		556
	],
	"./LanguageSwitcher.js": [
		735,
		735
	],
	"./MainMenu.js": [
		692,
		692
	],
	"./MiniCart.js": [
		719,
		719
	],
	"./Modal.js": [
		833,
		833
	],
	"./Parallax.js": [
		197,
		197
	],
	"./PizzaBasesHover.js": [
		234,
		234
	],
	"./PizzaImageSwitcher.js": [
		118,
		118
	],
	"./ProductPayButtons.js": [
		512,
		512
	],
	"./ProductTypeToggle.js": [
		223,
		223
	],
	"./QuantitySelector.js": [
		214,
		214
	],
	"./RecommendedSlider.js": [
		362,
		175,
		362
	],
	"./ShopRegisterOverlay.js": [
		363,
		363
	],
	"./Slider.js": [
		3,
		175,
		3
	],
	"./SliderTitolo.js": [
		352,
		352
	],
	"./UserTypeModal.js": [
		208,
		208
	],
	"./UserTypeSwitch.js": [
		421,
		421
	],
	"./VideoPlayer.js": [
		338,
		338
	],
	"./VimeoEmbed.js": [
		27,
		795,
		27
	],
	"./abstract/SwiperSlider.js": [
		386,
		175,
		386
	],
	"./menu/MenuOverlayAnimation.js": [
		73,
		73
	],
	"./menu/MenuScrollHandler.js": [
		292,
		292
	],
	"./menu/MenuStyleManager.js": [
		395,
		395
	],
	"./menu/MenuToggle.js": [
		115,
		115
	],
	"./menu/config.js": [
		230,
		230
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 771;
module.exports = webpackAsyncContext;